import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { busDangKyXeApi } from "../../../api/bus/busDangKyXeApi";
import { busDiemDonTraApi } from "../../../api/bus/busDiemDonTraApi";
import { busLoaiDiemDonApi } from "../../../api/bus/busLoaiDiemDonApi";
import { busTuyenDuongApi } from "../../../api/bus/busTuyenDuongApi";
import { busTuyenDuongChiTietApi } from "../../../api/bus/busTuyenDuongChiTietApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eBusPhanTuyenActionTypeIds,
	IBusPhanTuyenDeleteHocSinhStart,
	IBusPhanTuyenDeleteTuyenDuongChiTietStart,
	IBusPhanTuyenImportChiTietStart,
	IBusPhanTuyenLoadDiemDonTraStart,
	IBusPhanTuyenLoadHocSinhChuaPhanTuyenStart,
	IBusPhanTuyenLoadStart,
	IBusPhanTuyenLoadTuyenDuongChiTietStart,
	IBusPhanTuyenSavePhanTuyenHocSinhStart,
	IBusPhanTuyenSaveTuyenDuongChiTietStart,
	IBusPhanTuyenValidateImportChiTietStart
} from "../../action-types/bus/IBusPhanTuyenActionTypes";
import { busPhanTuyenActions } from "../../actions/bus/busPhanTuyenActions";

export function* busPhanTuyenSaga(): any {
	yield takeLatest(eBusPhanTuyenActionTypeIds.LOAD_START, loadBusPhanTuyenWorker)
	yield takeLatest(eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_START, loadBusTuyenDuongChiTietWorker)
	yield takeLatest(eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_START, loadBusDiemDonTraWorker)
	yield takeLatest(eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_START, loadBusLoaiDiemDonWorker)
	yield takeLatest(eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_START, loadHocSinhChuaPhanTuyenWorker)
	yield takeEvery(eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_START, saveBusTuyenDuongChiTietWorker)
	yield takeEvery(eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_START, deleteBusTuyenDuongChiTietWorker)
	yield takeEvery(eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_START, savePhanTuyenHocSinhWorker)
	yield takeEvery(eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_START, deleteHocSinhWorker)
	yield takeEvery(eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_START, validateImportTuyenDuongChiTietWorker)
	yield takeEvery(eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_START, importTuyenDuongChiTietWorker)
}

function* loadBusPhanTuyenWorker(action: IBusPhanTuyenLoadStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.SelectPhanTuyenAsync], action.payload)
	if (res.is_success) {
		yield put(busPhanTuyenActions.loadBusPhanTuyenSuccess(res.data || []))
	} else {
		yield put(busPhanTuyenActions.loadBusPhanTuyenError(res.message || "Không tải được danh sách phân tuyến"))
	}
}

function* loadBusTuyenDuongChiTietWorker(action: IBusPhanTuyenLoadTuyenDuongChiTietStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongChiTietApi, busTuyenDuongChiTietApi.SelectAsync], action.payload)
	if (res.is_success) {
		yield put(busPhanTuyenActions.loadBusTuyenDuongChiTietSuccess(res.data || []))
	} else {
		yield put(busPhanTuyenActions.loadBusTuyenDuongChiTietError(res.message || "Không tải được danh sách tuyến đường chi tiết"))
	}
}

function* loadBusDiemDonTraWorker(action: IBusPhanTuyenLoadDiemDonTraStart): any {
	const res: IBaseResponeModel = yield call([busDiemDonTraApi, busDiemDonTraApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(busPhanTuyenActions.loadBusDiemDonTraSuccess(res.data || []))
	} else {
		yield put(busPhanTuyenActions.loadBusDiemDonTraError(res.message || "Không tải được danh sách điểm đón trả"))
	}
}

function* loadBusLoaiDiemDonWorker(): any {
	const res: IBaseResponeModel = yield call([busLoaiDiemDonApi, busLoaiDiemDonApi.SelectAll])
	if (res.is_success) {
		yield put(busPhanTuyenActions.loadBusLoaiDiemDonSuccess(res.data || []))
	} else {
		yield put(busPhanTuyenActions.loadBusLoaiDiemDonError(res.message || "Không tải được danh sách loại điểm đón"))
	}
}

function* loadHocSinhChuaPhanTuyenWorker(action: IBusPhanTuyenLoadHocSinhChuaPhanTuyenStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.SelectChuaPhanTuyenAsync], action.payload)
	if (res.is_success) {
		yield put(busPhanTuyenActions.loadHocSinhChuaPhanTuyenSuccess(res.data || []))
	} else {
		yield put(busPhanTuyenActions.loadHocSinhChuaPhanTuyenError(res.message || "Không tải được danh sách học sinh chưa phân tuyến"))
	}
}

function* saveBusTuyenDuongChiTietWorker(action: IBusPhanTuyenSaveTuyenDuongChiTietStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([busTuyenDuongChiTietApi, busTuyenDuongChiTietApi.Update], action.payload);
	} else {
		res = yield call([busTuyenDuongChiTietApi, busTuyenDuongChiTietApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(busPhanTuyenActions.saveBusTuyenDuongChiTietSuccess(is_update))
	} else {
		yield put(busPhanTuyenActions.saveBusTuyenDuongChiTietError(res.message || "Có lỗi xảy ra"))
	}
}

function* deleteBusTuyenDuongChiTietWorker(action: IBusPhanTuyenDeleteTuyenDuongChiTietStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongChiTietApi, busTuyenDuongChiTietApi.Delete], action.payload)
	if (res.is_success) {
		yield put(busPhanTuyenActions.deleteBusTuyenDuongChiTietSuccess())
	} else {
		yield put(busPhanTuyenActions.deleteBusTuyenDuongChiTietError(res.message || "Không xoá được tuyến chi tiết"))
	}
}

function* savePhanTuyenHocSinhWorker(action: IBusPhanTuyenSavePhanTuyenHocSinhStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.UpdatePhanTuyenHocSinhAsync], action.payload)
	if (res.is_success) {
		yield put(busPhanTuyenActions.savePhanTuyenHocSinhSuccess())
	} else {
		yield put(busPhanTuyenActions.savePhanTuyenHocSinhError(res.message || "Không phân tuyến được học sinh"))
	}
}

function* deleteHocSinhWorker(action: IBusPhanTuyenDeleteHocSinhStart): any {
	const res: IBaseResponeModel = yield call([busDangKyXeApi, busDangKyXeApi.UpdateHuyDangKy], action.payload)
	if (res.is_success) {
		yield put(busPhanTuyenActions.deleteHocSinhSuccess())
	} else {
		yield put(busPhanTuyenActions.deleteHocSinhError(res.message || "Không xoá được học sinh khỏi tuyến"))
	}
}

function* validateImportTuyenDuongChiTietWorker(action: IBusPhanTuyenValidateImportChiTietStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongChiTietApi, busTuyenDuongChiTietApi.ValidateImport], action.payload)
	if (res.is_success) {
		yield put(busPhanTuyenActions.validateImportTuyenDuongChiTietSuccess(res.data || []))
	} else {
		yield put(busPhanTuyenActions.validateImportTuyenDuongChiTietError(res.message || "Có lỗi"))
	}
}

function* importTuyenDuongChiTietWorker(action: IBusPhanTuyenImportChiTietStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongChiTietApi, busTuyenDuongChiTietApi.Import], action.payload)
	if (res.is_success) {
		yield put(busPhanTuyenActions.importTuyenDuongChiTietSuccess())
	} else {
		yield put(busPhanTuyenActions.importTuyenDuongChiTietError(res.message || "Có lỗi"))
	}
}
